import React from "react";
import { Link } from "react-router-dom";
//import { Button } from '../../globalStyles';
import Button from "@material-ui/core/Button";
//import { AiFillThunderbolt } from 'react-icons/ai';
import { GiCrystalBars } from "react-icons/gi";
import { GiCutDiamond, GiRock } from "react-icons/gi";
//import { GiFloatingCrystal } from 'react-icons/gi';
import { IconContext } from "react-icons/lib";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  PricingSection: {
    padding: "100px 0 160px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    //background: "#000000",
  },
  PricingWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: "0 auto",
    "@media screen and (max-width: 960px)": {
      margin: "0 30px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
  },
  PricingHeading: {
    color: "#fff",
    fontSize: "48px",
    marginBottom: "24px",
  },
  PricingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "@media screen and (max-width: 960px)": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
    },
  },
  PricingCard: {
    background: "#242424",
    boxShadow: "0 6px 20px rgba(56, 125, 255, 0.2)",
    width: "280px",
    height: "550px",
    textDecoration: "none",
    borderRadius: "4px",
    "&:nth-child(2)": {
      margin: "24px",
    },
    "&:hover": {
      transform: "scale(1.06)",
      transition: "all 0.3s ease-out",
      color: "#1c2237",
    },
    "@media screen and (max-width: 960px)": {
      width: "90%",
      "&:hover": {
        transform: "none",
      },
    },
  },
  PricingCardInfo: {
    display: "flex",
    flexDirection: "column",
    height: "500px",
    padding: "24px",
    alignItems: "center",
    color: "#fff",
  },
  PricingCardIcon: {
    margin: "24px 0",
  },
  PricingCardPlan: {
    marginBottom: "5px",
    fontSize: "24px",
  },
  PricingCardCost: {
    fontSize: "40px",
  },
  PricingCardLength: {
    fontSize: "14px",
    marginBottom: "24px",
  },
  PricingCardFeatures: {
    margin: "16px 0 32px",
    listStyle: "none",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: "#a9b3c1",
  },
  PricingCardFeature: {
    marginBottom: "10px",
  },
}));

function Pricing() {
  const classes = useStyles();
  return (
    <IconContext.Provider value={{ color: "#ffffc1", size: 64 }}>
      <div id="service" className={classes.PricingSection}>
        <div className={classes.PricingWrapper}>
          <h1 className={classes.PricingHeading}>Our Services</h1>
          <div className={classes.PricingContainer}>
            <Link className={classes.PricingCard} to="/login">
              <div className={classes.PricingCardInfo}>
                <div className={classes.PricingCardIcon}>
                  <GiRock />
                </div>
                <h3 className={classes.PricingCardPlan}>Starter Pack</h3>
                <h4 className={classes.PricingCardCost}>$99.99</h4>
                <p className={classes.PricingCardLength}>per month</p>
                <ul className={classes.PricingCardFeatures}>
                  <li className={classes.PricingCardFeature}>100 New Users</li>
                  <li className={classes.PricingCardFeature}>$10,000 Budget</li>
                  <li className={classes.PricingCardFeature}>
                    Retargeting analytics
                  </li>
                </ul>
                <Button variant="contained" color="secondary">
                  Choose Plan
                </Button>
              </div>
            </Link>
            <Link className={classes.PricingCard} to="/login">
              <div className={classes.PricingCardInfo}>
                <div className={classes.PricingCardIcon}>
                  <GiCrystalBars />
                </div>
                <h3 className={classes.PricingCardPlan}>Gold Rush</h3>
                <h4 className={classes.PricingCardCost}>$299.99</h4>
                <p className={classes.PricingCardLength}>per month</p>
                <ul className={classes.PricingCardFeatures}>
                  <li className={classes.PricingCardFeature}>1000 New Users</li>
                  <li className={classes.PricingCardFeature}>$50,000 Budget</li>
                  <li className={classes.PricingCardFeature}>
                    Lead Gen Analytics
                  </li>
                </ul>
                <Button variant="contained" color="secondary">
                  Choose Plan
                </Button>
              </div>
            </Link>
            <Link className={classes.PricingCard} to="/login">
              <div className={classes.PricingCardInfo}>
                <div className={classes.PricingCardIcon}>
                  <GiCutDiamond />
                </div>
                <h3 className={classes.PricingCardPlan}>Diamond Kings</h3>
                <h4 className={classes.PricingCardCost}>$999.99</h4>
                <p className={classes.PricingCardLength}>per month</p>
                <ul className={classes.PricingCardFeatures}>
                  <li className={classes.PricingCardFeature}>
                    Unlimited Users
                  </li>
                  <li className={classes.PricingCardFeature}>
                    Unlimited Budget
                  </li>
                  <li className={classes.PricingCardFeature}>24/7 Support</li>
                </ul>
                <Button variant="contained" color="secondary">
                  Choose Plan
                </Button>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </IconContext.Provider>
  );
}
export default Pricing;
